exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addhead[data-v-0d2c129a]{margin-top:20px;margin-right:20px}.addhead ul[data-v-0d2c129a]{padding-right:20px}.addhead ul li[data-v-0d2c129a]{width:100%}.avatar-uploader .el-upload[data-v-0d2c129a]{border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-0d2c129a]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-0d2c129a]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center;border:1px dashed #d9d9d9}.avatar[data-v-0d2c129a]{width:178px;height:178px;display:block}\n", ""]);

// exports
